import React, { useState } from "react";
import { connect } from "react-redux";
import { userLoginReducer, mapDispatchToProps } from "./Login.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import Login from "../../library/Login/Login";
import { modalType, roles } from "../../../modules/constants";
import { useTranslation } from "react-i18next";

export const SmartLogin = (props) => {
  const { setOpenAuthModal, login, closeModalGoHome } = props;

  const { t } = useTranslation();

  const [errorMessage, setErrorMessage] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const submitHandler = (username, password) => {
    if (username && password) {
      setButtonDisabled(true);
      login({ username, password })
        .then((res) => {
          if (res?.passwordToken) {
            setOpenAuthModal(
              modalType.changePassword,
              t("contentText.changePassword.title")
            );
          } else if (
            res?.acceptedTermsAndConditions === false &&
            res?.decryptedRole === roles.participant
          ) {
            setOpenAuthModal(
              modalType.notice,
              t("contentText.privacyPolicy.notice.title")
            );
          } else {
            closeModalGoHome();
          }
        })
        .catch((err) => {
          setButtonDisabled(false);
          setErrorMessage(err);
        });
    } else {
      if (!username && !password) {
        setErrorMessage(t("errorText.auth.login.empty.credentials"));
      } else if (!username && password) {
        setErrorMessage(t("errorText.auth.login.empty.emailOrParticipantID"));
      } else if (username && !password) {
        setErrorMessage(t("errorText.auth.login.empty.password"));
      }
    }
  };

  const forgotPasswordHandler = () => {
    setOpenAuthModal(
      modalType.recoverPassword,
      t("contentText.passwordRecovery.title")
    );
  };

  return (
    <Login
      onSubmit={submitHandler}
      errorMessage={errorMessage}
      onForgotPassword={forgotPasswordHandler}
      buttonDisabled={buttonDisabled}
    />
  );
};

export default dynamic(
  "userLoginReducer",
  subspaced({
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(userLoginReducer)
)(connect(null, mapDispatchToProps)(SmartLogin));
